import React from 'react';
import { theme } from '../theme';

// ---------------------------------------------------------------------------
// SddChipsAndWarnings — shared render of SDD schema chips + column warnings.
// Used by GenerateSQL (in the Right Panel) and by SplitPane (above editor on
// AI-generated tabs, especially after a "Retry with AI" correction).
// If both arrays are empty, renders nothing.
// ---------------------------------------------------------------------------
export default function SddChipsAndWarnings({ sddContext = [], sddWarnings = [], assumptions = [], onDismiss, compact = false }) {
  if (!sddContext.length && !sddWarnings.length && !assumptions.length) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', padding: compact ? '4px 0' : '4px 2px' }}>
      {sddContext.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px' }}>
          <span style={{ fontSize: '10px', color: theme.textMuted, flexShrink: 0 }}>Schemas used:</span>
          {sddContext.map(t => (
            <span
              key={t.name}
              title={t.module}
              style={{
                padding: '2px 7px', fontSize: '10px', fontFamily: 'monospace',
                fontWeight: 600, borderRadius: '4px', cursor: 'default',
                background: `${theme.accent}18`, color: theme.accent,
                border: `1px solid ${theme.accent}33`,
              }}
            >
              {t.name}
            </span>
          ))}
          {onDismiss && (
            <button
              onClick={onDismiss}
              title="Dismiss"
              style={{
                marginLeft: 'auto', background: 'none', border: 'none',
                color: theme.textMuted, cursor: 'pointer', padding: '2px 6px',
                fontSize: '11px', borderRadius: '3px',
              }}
            >
              ×
            </button>
          )}
        </div>
      )}

      {assumptions.length > 0 && (
        <div style={{
          display: 'flex', flexDirection: 'column', gap: '4px',
          padding: '7px 9px', borderRadius: '6px',
          background: `${theme.textMuted}0f`,
          border: `1px solid ${theme.border}`,
        }}>
          <div style={{ fontSize: '10px', fontWeight: 700, color: theme.textMuted, letterSpacing: '0.02em' }}>
            HOW THIS WAS INTERPRETED
          </div>
          {assumptions.map((a, i) => (
            <div key={i} style={{
              fontSize: '11px', color: theme.textMuted, lineHeight: 1.5,
              borderLeft: `2px solid ${theme.border}`, paddingLeft: '6px',
            }}>
              {a}
            </div>
          ))}
        </div>
      )}

      {sddWarnings.length > 0 && (
        <div style={{
          display: 'flex', flexDirection: 'column', gap: '5px',
          padding: '8px 10px', borderRadius: '6px',
          background: `${theme.warning}12`,
          border: `1px solid ${theme.warning}40`,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '11px', fontWeight: 700, color: theme.warning }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            Column warnings ({sddWarnings.length})
          </div>
          {sddWarnings.map((w, i) => (
            <div key={i} style={{ fontSize: '11px', color: theme.text, lineHeight: 1.5, borderLeft: `2px solid ${theme.warning}60`, paddingLeft: '6px' }}>
              <span style={{ fontFamily: 'monospace', color: theme.warning, fontWeight: 600 }}>{w.alias}.{w.column}</span>
              {' on '}
              <span style={{ fontFamily: 'monospace' }}>{w.table}</span>
              {' — '}
              <span style={{ color: theme.textMuted }}>{w.suggestion}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
